export enum DosyaSorguTipleriEnum {
    KOSUL_YOK = 0,
    DUSECEK_OLAN_DOSYALAR = 1,
    SGK_AKTIF_OLAN_DOSYALAR = 2,
    EGM_ARACI_OLAN_BORCLULAR = 3
}